// oxlint-disable-next-line no-redeclare
export const EOF = '\0';

export const VIEW_PREFIX = 'view:';

export type EOF = typeof EOF;

export const ROLE_ATTRIBUTE_PREFIX = '${roleAttribute/';
// Regex to match role attribute syntax
// e.g. ${roleAttribute/devProjectKey}
export const ROLE_ATTRIBUTE_REGEX = /\$\{roleAttribute\/([^}]+)\}/;
